import { ErrorModel } from '@era/app';
import { createActionGroup, props } from '@ngrx/store';
import { CategoryType } from '../shared/types';
import { ApplicationConfiguration } from './category-applications.state';

// ============================================================================
// RESOLVER ACTIONS
// ============================================================================

export const CategoryApplicationsResolverActions = createActionGroup({
  source: 'Category applications resolver',
  events: {
    'Category applications requested': props<{ id: string; categoryType: CategoryType }>(),
  },
});

export const DeviceConfiguredApplicationsResolverActions = createActionGroup({
  source: 'Device configured application resolver',
  events: {
    'Category applications requested': props<{ id: string; categoryType: CategoryType }>(),
  },
});

// ============================================================================
// API ACTIONS
// ============================================================================

export const ApplicationsApiActions = createActionGroup({
  source: 'Applications API',
  events: {
    'Category applications loaded': props<{ applications: ApplicationConfiguration[]; categoryType: CategoryType }>(),
    'Category applications loaded error': props<{ error: ErrorModel }>(),
    'Category application configurations updated error': props<{
      id: string;
      categoryType: CategoryType;
      error: ErrorModel;
    }>(),
  },
});

// ============================================================================
// VIEW ACTIONS
// ============================================================================

export const CategoryApplicationViewActions = createActionGroup({
  source: 'Category application view',
  events: {
    'Application configurations updated': props<{
      id: string;
      categoryType: CategoryType;
      previousApplicationsLinkedToCategory: ApplicationConfiguration[];
      updatedApplicationsLinkedToCategory: ApplicationConfiguration[];
    }>(),
  },
});

// ============================================================================
// EFFECT ACTIONS
// ============================================================================

export const CategoryApplicationsEffectActions = createActionGroup({
  source: 'Category effects',
  events: {
    'Category applications requested': props<{ id: string; categoryType: CategoryType }>(),
  },
});
